import { ProductPayload } from '../types/productPayload'

interface ProductPayloadColumn {
  key: keyof ProductPayload
  labelKey: string
}

export const productPayloadColumns: ProductPayloadColumn[] = [
  { key: 'name', labelKey: 'products.table.column.name' },
  { key: 'productType', labelKey: 'products.import.column.product_type' },
  { key: 'description', labelKey: 'products.import.column.description' },
  { key: 'unit', labelKey: 'products.import.column.unit' },
  { key: 'price', labelKey: 'products.table.column.price_excluding_vat' },
  { key: 'vatPct', labelKey: 'products.table.column.vat' },
  { key: 'vatRateId', labelKey: 'products.import.column.vat_rate_id' },
  { key: 'accountId', labelKey: 'products.import.column.account_no' },
]
